// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.driver-popover{
    background-color: white;
    border-radius: 10px;
    padding: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-width: 400px;
}

.driver-popover-title{
    padding: 10px 16px;
    background-color: var(--bg1);
    border-bottom: 2px solid var(--border);
    border-radius: 10px 10px 0 0;
}

.driver-popover-footer{
    justify-content: space-between;
    align-items: center;
    margin-top: 0;
    padding: 10px 16px;
    border-top: 2px solid var(--border);
    border-radius: 0 0 10px 10px;
}

.driver-popover-navigation-btns{
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    align-items: center;
}

.driver-popover-navigation-btns button {
    padding: 8px 20px;
    font-size: 14px;
    font-weight: bold;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    background-color: var(--brand);
    color: var(--white);
    border: 1px solid var(--brand);
    transition: background-color 0.2s;
    /*  */

    text-shadow: none;
    font-family: var(--font-inter);
}

.driver-popover-footer button:hover, .driver-popover-footer button:focus{
    background-color: var(--border);
    color: var(--primary-Text);
}

.driver-popover-footer .driver-popover-btn-disabled{
    opacity: 0;
}

.driver-popover-close-btn {
    position: absolute;
    top: 14px;
    right: 16px;
    font-size: 22px;
    font-weight: bold;
    line-height: 1;
    background-color: transparent;
    padding: 0;
    filter: grayscale(100%);
    color: var(--brand);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
}

.driver-popover-title{
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 0;
}

.driver-popover-description{
    font-size: 16px;
    color: var(--primary-Text);
    line-height: 1.5;
    padding: 10px 16px;
    margin-top: 0;
}

.driver-popover-title[style*=block]+.driver-popover-description{
    margin-top: 0;
}

.driver-popover-progress-text{
    font-size: 14px;
    color: var(--primary-Text);
    font-weight: bold;
    padding: 4px 8px;
    background-color: var(--bg3);
    border-radius: 6px;
    border: 1px solid var(--border);
}`, "",{"version":3,"sources":["webpack://./src/context/driver.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,sCAAsC;IACtC,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mCAAmC;IACnC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;IAC9B,iCAAiC;IACjC,KAAK;;IAEL,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,6BAA6B;IAC7B,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB,+BAA+B;AACnC","sourcesContent":[".driver-popover{\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    padding: 0;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    max-width: 400px;\r\n}\r\n\r\n.driver-popover-title{\r\n    padding: 10px 16px;\r\n    background-color: var(--bg1);\r\n    border-bottom: 2px solid var(--border);\r\n    border-radius: 10px 10px 0 0;\r\n}\r\n\r\n.driver-popover-footer{\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-top: 0;\r\n    padding: 10px 16px;\r\n    border-top: 2px solid var(--border);\r\n    border-radius: 0 0 10px 10px;\r\n}\r\n\r\n.driver-popover-navigation-btns{\r\n    display: flex;\r\n    gap: 8px;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n}\r\n\r\n.driver-popover-navigation-btns button {\r\n    padding: 8px 20px;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    border: none;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    background-color: var(--brand);\r\n    color: var(--white);\r\n    border: 1px solid var(--brand);\r\n    transition: background-color 0.2s;\r\n    /*  */\r\n\r\n    text-shadow: none;\r\n    font-family: var(--font-inter);\r\n}\r\n\r\n.driver-popover-footer button:hover, .driver-popover-footer button:focus{\r\n    background-color: var(--border);\r\n    color: var(--primary-Text);\r\n}\r\n\r\n.driver-popover-footer .driver-popover-btn-disabled{\r\n    opacity: 0;\r\n}\r\n\r\n.driver-popover-close-btn {\r\n    position: absolute;\r\n    top: 14px;\r\n    right: 16px;\r\n    font-size: 22px;\r\n    font-weight: bold;\r\n    line-height: 1;\r\n    background-color: transparent;\r\n    padding: 0;\r\n    filter: grayscale(100%);\r\n    color: var(--brand);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    opacity: 1;\r\n}\r\n\r\n.driver-popover-title{\r\n    font-size: 22px;\r\n    font-weight: bold;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.driver-popover-description{\r\n    font-size: 16px;\r\n    color: var(--primary-Text);\r\n    line-height: 1.5;\r\n    padding: 10px 16px;\r\n    margin-top: 0;\r\n}\r\n\r\n.driver-popover-title[style*=block]+.driver-popover-description{\r\n    margin-top: 0;\r\n}\r\n\r\n.driver-popover-progress-text{\r\n    font-size: 14px;\r\n    color: var(--primary-Text);\r\n    font-weight: bold;\r\n    padding: 4px 8px;\r\n    background-color: var(--bg3);\r\n    border-radius: 6px;\r\n    border: 1px solid var(--border);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
